import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { ActivityTypeReferenceModel } from '../../models/reference-model/reference-general-model/activity-type-reference.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityTypeReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/ActivityTypeReference";
  
  constructor(httpClient: HttpClient,
    authService: AuthService) {
    super(httpClient, authService);
  }

  public getActivityTypeReferencesByDomainCode(domainCode: string): Observable<ActivityTypeReferenceModel[]> {
    return this.httpGet<ActivityTypeReferenceModel[]>(this.PATH + "/domain/" + domainCode, null)
      .pipe(
        map(response => response.body)
      );
  }
}
